import { render } from "./PanelRight.vue?vue&type=template&id=017111a3"
import script from "./PanelRight.vue?vue&type=script&lang=js"
export * from "./PanelRight.vue?vue&type=script&lang=js"

import "./PanelRight.vue?vue&type=style&index=0&id=017111a3&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__